// Copyright (c) 2020 Deere & Company
import './index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledDatePicker from '../../shared/components/labeled-date-picker';
import OptionsDropDown from '../../shared/components/options-drop-down';
import OrderPushedOutTable from './components/order-pushed-out-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFamiliesFactory } from '../../common/repositories';
import { getOrderPushedOut } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class orderPushedOut extends Component {

    state = {
        familyTypes: [],
        selectedFamilyType: '',
        transactionStartDate: '',
        transactionEndDate: '',
        results: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamiliesFactory( 'Y', 'Y' ).then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleStartDateChange = val => {

        this.setState( {
            transactionStartDate: val
        } );

    }

    handleEndDateChange = val => {

        this.setState( {
            transactionEndDate: val
        } );

    }

    refresh () {

        this.props.increaseCounter();
        const family = this.state.selectedFamilyType;
        const startDate = this.state.transactionStartDate;
        const endDate = this.state.transactionEndDate;
        getOrderPushedOut( family, startDate, endDate )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            selectedFamilyType, familyTypes, results
        } = this.state;

        const additionalInfo = ( results !== null ? {
            unitName: this.props.unit.name
        } : '' );
        const pushedOutResult = results.map( i => ( { ...i, ...additionalInfo } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header"> Order Pushed Out </h2>
                </header>
                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-pushed-out-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-order-pushed-out-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />
                                <LabeledDatePicker
                                    selected={this.state.transactionStartDate}
                                    onChange={this.handleStartDateChange.bind( this )}
                                    name="transactionStartDate"
                                    label="Transaction Start Date:"
                                    maxDate={new Date()}
                                    dateFormat="MM/dd/yyyy"
                                />
                                <LabeledDatePicker
                                    selected={this.state.transactionEndDate}
                                    onChange={this.handleEndDateChange.bind( this )}
                                    name="transactionEndDate"
                                    label="Transaction End Date:"
                                    minDate={this.state.transactionStartDate}
                                    maxDate={new Date()}
                                    dateFormat="MM/dd/yyyy"
                                />
                                {selectedFamilyType && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                        </div>
                        {selectedFamilyType && (
                            <OrderPushedOutTable
                                results={pushedOutResult}
                                totalRows={results.length}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

orderPushedOut.displayName = 'orderPushedOut';
orderPushedOut.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( orderPushedOut ) );
